import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pa-4" }

import RichText from "@/components/base/inputs/RichText.vue";
import { useAMPStore } from "@/store/asset-management-plan";
import RiskRegisterLinkTable from "../links/RiskRegisterLinkTable.vue";
import { Deleteable } from "@/classes/asset-management-plan";


export default /*#__PURE__*/_defineComponent({
  __name: 'AssetInformation',
  props: {
    readonly: { type: Boolean }
  },
  emits: ["delete"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const store = useAMPStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(RichText, {
      modelValue: _unref(store).plan.ownership_responsibility,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(store).plan.ownership_responsibility) = $event)),
      label: "4.1 Ownership & Responsibility",
      class: "mb-4",
      required: "",
      readonly: _ctx.readonly
    }, null, 8, ["modelValue", "readonly"]),
    _createVNode(RichText, {
      modelValue: _unref(store).plan.asset_class_description,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(store).plan.asset_class_description) = $event)),
      label: "4.2 Asset Class & Description",
      class: "mb-4",
      required: "",
      readonly: _ctx.readonly
    }, null, 8, ["modelValue", "readonly"]),
    _createVNode(RichText, {
      modelValue: _unref(store).plan.selection_procurement,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(store).plan.selection_procurement) = $event)),
      label: "4.3 Selection & Procurement",
      class: "mb-4",
      required: "",
      readonly: _ctx.readonly
    }, null, 8, ["modelValue", "readonly"]),
    _createVNode(RichText, {
      modelValue: _unref(store).plan.risk_register,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(store).plan.risk_register) = $event)),
      label: "4.4 Risk Register",
      class: "mb-4",
      required: "",
      readonly: _ctx.readonly
    }, null, 8, ["modelValue", "readonly"]),
    _createVNode(RiskRegisterLinkTable, {
      class: "mb-4",
      readonly: _ctx.readonly,
      onDelete: _cache[4] || (_cache[4] = ($event: any) => (emit('delete', $event)))
    }, null, 8, ["readonly"])
  ]))
}
}

})